import { render } from "./abstractIcon.vue?vue&type=template&id=e1fd7628&scoped=true"
import script from "./abstractIcon.vue?vue&type=script&lang=js"
export * from "./abstractIcon.vue?vue&type=script&lang=js"

import "./abstractIcon.vue?vue&type=style&index=0&id=e1fd7628&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1fd7628"]])

export default __exports__